import { USER_ROLE_ANONYMOUS } from 'common/userRoles';
import { SR_API_ACTION_UPDATE_USER_DEVICE_REGISTRATION_IDS } from 'api/actionTypes';

export default async function updateDeviceRegistrationIds(
  { state, apiClient },
  { newDeviceRegistrationId, oldDeviceRegistrationId },
) {
  const userRoles = state.get(['currentUser', 'roles']);
  const isAnonymous = userRoles.includes(USER_ROLE_ANONYMOUS);

  if (!isAnonymous) {
    await apiClient.postWithState({
      action: SR_API_ACTION_UPDATE_USER_DEVICE_REGISTRATION_IDS,
      state: state,
      payload: {
        newDeviceRegistrationId,
        oldDeviceRegistrationId,
        isPartnerApp: state.get(['mobileApp', 'isPartnerApp']),
      },
      onSuccess() {
        state.set(['mobileApp', 'deviceRegistrationId'], newDeviceRegistrationId);
        state.set(['mobileApp', 'askedPushNotificationPermission'], true);
      },
    });
  }
}
